module.exports = __webpack_public_path__ + "img/inventory.91c28281.png";